var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('img',{class:{active: _vm.connected, 'mb-icon': true},attrs:{"src":require("../../../public/img/blank.png"),"alt":"micro:bit"}}),_c('div',{staticClass:"group-select-box"},[_c('button',{on:{"click":_vm.connectUsb}},[_vm._v(" "+_vm._s(_vm.$t(_vm.connectButtonString))+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }